/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Button, Col, Row, Spin, Steps, Upload } from "antd";
import "./index.css";
import PropTypes from "prop-types";
import { toast, ToastContainer } from "react-toastify";
import { useHistory } from "react-router";
import { BulbFilled, UploadOutlined, CheckOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import * as XLSX from "xlsx";
import Spreadsheet from "react-spreadsheet";
import Spinners from "../../components/spinner/Spinner";
import api from "../../helpers";
import { PiFalloutShelterDuotone } from "react-icons/pi";
import useMedia from "use-media-antd-query";
import { useDispatch, useSelector } from "react-redux";
import { loadStateList } from "../../store/parties/actions";

const CustomerImport = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const organizationId = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  useEffect(() => {
    dispatch(loadStateList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Reducer state
  const { state_list = [] } = useSelector((state) => state.Parties);

  console.log(state_list, "state_list");
  const stateList =
    state_list.length > 0
      ? state_list.map((c) => {
          return {
            States: c.stateName,
          };
        })
      : [];
  //Imported section
  const [importPreview, setImportPreview] = useState(false);
  const [importedData, setImportedData] = useState("");
  const [current, setCurrent] = useState(0);
  const [files, setFiles] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [removing, setRemoving] = useState(false);

  const uploadChanged = (event) => {
    // setFiles(event);
    if (event.file) {
      setFiles(event.file);
      var fileArrayDetails = event.file;
      var formData = new FormData();
      formData.append("file", fileArrayDetails);
      setUploading(true);
      setTimeout(() => {
        if (event.fileList && event.fileList.length == 0) {
          setTimeout(() => {
            setUploading(false);
          }, 1000);
        } else {
          api
            .post(`/org/partyupload-excel`, formData)
            .then(async (res) => {
              if (res && res.data) {
                setImportedData(res.data.excelData);
                toast.success("Data Uploaded successfully");
                // if (res.data.excelData.length > 0) {
                // setCurrent(1);
                // } else {
                //   toast.error("Add all the required fields in sheet");
                // }
                setCurrent(1);
                setImportPreview(true);
                setTableLoading(true);
                setTimeout(() => {
                  setTableLoading(false);
                }, 1500);
                await setFiles(res.data);
              }
            })
            .catch((error) => {
              // console.log(error, "error");
              setFiles([]);
              const errorMsg =
                (error &&
                  error.response &&
                  error.response.data &&
                  error.response.data.error) ||
                (error &&
                  error.response &&
                  error.response.data &&
                  error.response.data.message);
              toast.error(errorMsg);
              Promise.reject(error);
            });
          setTimeout(() => {
            setUploading(false);
          }, 1000);
        }
      }, 1000);
      // console.log(formData, "formData");
    }
  };

  const columns = [
    {
      title: "S.No",
      key: "s.no",
      width: 70,
      dataIndex: "s.no",
    },
    {
      title: "Party Name",
      key: "partyName",
      width: 140,
      dataIndex: "partyName",
    },
    {
      title: "Mobile No",
      key: "mobilenumber",
      width: 140,
      dataIndex: "mobilenumber",
    },
    {
      title: "Address",
      key: "address",
      width: 140,
      dataIndex: "address",
    },
    {
      title: "City",
      key: "city",
      width: 140,
      dataIndex: "city",
    },
    {
      title: "State",
      key: "state",
      width: 140,
      dataIndex: "state",
    },
    {
      title: "Pincode",
      key: "pincode",
      width: 140,
      dataIndex: "pincode",
    },
  ];

  //Pagination Component
  const downloadExcel = ({ fileName, sheets, fileType }) => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();
    // Add sheets to the workbook
    sheets.forEach(({ sheetName, data }) => {
      const worksheet = XLSX.utils.json_to_sheet(data); // Convert JSON to a sheet
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    });

    // Generate Excel file and trigger download
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    // const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const blob = new Blob([excelBuffer], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
    // const a = document.createElement("a");
    // a.download = fileName;
    // a.href = window.URL.createObjectURL(blob);
    // a.click();
    // a.remove();
  };

  const downloadTemplate = () => {
    let headerData = [
      {
        sno: "",
        partyname: "",
        mobilenumber: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
      },
    ];
    downloadExcel({
      // data: [...headerData].join("\n"),
      fileName: "Customer-Template.xlsx",
      sheets: [
        {
          sheetName: "Customer Template",
          data: headerData,
        },
        {
          sheetName: "State List",
          data: stateList,
        },
      ],
      fileType: "text/csv",
    });
  };

  //data table
  const importedDataTable =
    importedData && importedData.length > 0
      ? importedData.map((data, index) => {
          const finalOutput = [
            { value: index + 1 },
            { value: data.partyname },
            { value: data.mobilenumber },
            { value: data.address },
            { value: data.city },
            { value: data.state },
            { value: data.pincode },
          ];
          return finalOutput;
        })
      : [];
  const columnLabels = [
    "S.No",
    "Party Name",
    "Mobile No",
    "Address",
    "City",
    "State",
    "Pincode",
  ];
  const rowLabels =
    importedData && importedData && importedData.length > 0
      ? importedData.map((data, index) => {
          console.log(data);
          return index + 1;
        })
      : [];

  const importedDataValue =
    importedData && importedData.length > 0
      ? importedData.map((data, index) => {
          return {
            "s.no": index + 1,
            // "s.no": data.s.no,
            partyname: data.partyname,
            mobilenumber: data.mobilenumber,
            address: data.address,
            city: data.city,
            state: data.state,
            pincode: data.pincode,
          };
        })
      : [];

  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const importedPurchaseInvoice = () => {
    setIsButtonDisabled(true);
    setTimeout(() => {
      setIsButtonDisabled(false);
    }, 4000);
    api
      .post(
        `/org/createpartyimport/${organizationId}/${userId}`,
        importedDataValue
      )
      .then((res) => {
        console.log(res.data, "import response");
        toast.info("Customer Imported successfully");
        setTimeout(() => {
          history.push("/parties");
          setImportPreview(false);
        }, 1500);
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message);
        toast.error(errorMsg);
        Promise.reject(error);
      })
      .catch((error) => Promise.reject(error));
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const media = useMedia();

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Customer Import | Mbook</title>
        </MetaTags>
      </div>

      <Row className="">
        <Col md={24} lg={24} sm={24} xs={24} className="bg-[white]">
          <Row className="mt-[-4px] bg-[white] flex justify-center purchase-invoice-details-header">
            <Col md={12} className="p-2">
              <div className="font-poppins flex justify-center pl-[20px] pr-[20px]">
                <div>
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className={
                      importPreview == true
                        ? "text-[16px] text-[#5a95bd] ml-2 font-semibold"
                        : "text-[16px] ml-2 font-semibold"
                    }
                  >
                    {"Customer Import"}
                  </h1>
                </div>
              </div>
            </Col>
          </Row>

          <Row
            className={
              windowDimensions.height >= 700 && windowDimensions.height < 730
                ? "item-import-main-card-medium-device"
                : (windowDimensions.height >= 730 &&
                    windowDimensions.height <= 767) ||
                  (windowDimensions.height > 767 &&
                    windowDimensions.height < 830)
                ? "customer-import-main-card-large-device"
                : windowDimensions.height > 830
                ? "item-import-main-card-extra-large-device"
                : "item-import-main-card"
            }
          >
            <Col
              md={24}
              className={
                (windowDimensions.height >= 700 &&
                  windowDimensions.height <= 767) ||
                (windowDimensions.height > 767 && windowDimensions.height < 830)
                  ? "h-[450px]"
                  : "h-[370px]"
              }
            >
              {/* Import file */}
              <Row className="bg-[white] flex justify-center mt-3">
                <Col md={10} className="">
                  <Steps
                    current={current}
                    // onChange={statusOnChange}
                    responsive={true}
                    type=""
                    items={[
                      {
                        title: "Upload",
                      },
                      {
                        title: "Preview",
                      },
                    ]}
                  />
                </Col>
              </Row>
              {importPreview == true && current == 1 ? (
                <Row>
                  <Col
                    md={24}
                    lg={24}
                    xs={24}
                    sm={24}
                    className={
                      (windowDimensions.height >= 700 &&
                        windowDimensions.height <= 767) ||
                      (windowDimensions.height > 767 &&
                        windowDimensions.height < 830)
                        ? "bg-[white] h-[470px] mt-3"
                        : "bg-[white] h-[430px] mt-3"
                    }
                  >
                    {tableLoading == true ? (
                      <Row>
                        <Spinners mode="import" />
                      </Row>
                    ) : (
                      // <Row>
                      <Row
                        className={
                          media == "xxl"
                            ? "purchase-invoice-import-content flex justify-center"
                            : "purchase-invoice-import-content flex justify-center"
                        }
                      >
                        <Col
                          md={24}
                          lg={24}
                          xs={24}
                          sm={24}
                          className="flex justify-center pointer-events-none opacity-1 pl-4"
                        >
                          <Row>
                            <Col
                              md={media == "xxl" ? 14 : 24}
                              lg={media == "xxl" ? 14 : 24}
                              xs={media == "xxl" ? 14 : 24}
                              sm={media == "xxl" ? 14 : 24}
                            >
                              <Spreadsheet
                                data={importedDataTable}
                                columnLabels={columnLabels}
                                DataEditor={false}
                                rowLabels={rowLabels}
                                className="w-[100%]"
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col
                        md={24}
                        lg={24}
                        xs={24}
                        sm={24}
                        className="pr-4 pl-4 mt-5"
                      >
                        <div className="w-[100%] flex justify-between">
                          <Button
                            style={{
                              fontFamily: "Poppins",
                            }}
                            onClick={() => {
                              setImportPreview(false);
                              setCurrent(0);
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            style={{
                              fontFamily: "Poppins",
                            }}
                            disabled={isButtonDisabled ? true : false}
                            type="primary"
                            onClick={() => importedPurchaseInvoice()}
                          >
                            Import
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row className="pl-5 pr-5 mt-3">
                  <Col
                    md={14}
                    className={
                      (windowDimensions.height >= 700 &&
                        windowDimensions.height <= 767) ||
                      (windowDimensions.height > 767 &&
                        windowDimensions.height < 830)
                        ? "border border-1 p-2 rounded-md h-[410px]"
                        : windowDimensions.height > 830
                        ? "border border-1 p-2 rounded-md h-[392px]"
                        : "border border-1 p-2 rounded-md h-[270px]"
                    }
                  >
                    <div
                      className={
                        (windowDimensions.height >= 700 &&
                          windowDimensions.height <= 767) ||
                        (windowDimensions.height > 767 &&
                          windowDimensions.height < 830)
                          ? "w-[100%] flex justify-center align-center border rounded-md border-2 border-dashed h-[390px]"
                          : windowDimensions.height > 830
                          ? "w-[100%] flex justify-center align-center border rounded-md border-2 border-dashed h-[375px]"
                          : "w-[100%] flex justify-center align-center border rounded-md border-2 border-dashed h-[250px]"
                      }
                    >
                      <div
                        className={
                          (windowDimensions.height >= 700 &&
                            windowDimensions.height <= 767) ||
                          (windowDimensions.height > 767 &&
                            windowDimensions.height < 830)
                            ? "pt-[150px]"
                            : windowDimensions.height >= 830
                            ? "pt-[150px]"
                            : "pt-20"
                        }
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                        >
                          <h1 className="text-center">Drag your file here</h1>
                          <p className="text-center">Or</p>
                        </div>
                        <Upload
                          name="file"
                          showUploadList={{
                            showRemoveIcon: PiFalloutShelterDuotone,
                          }}
                          onRemove={() => {
                            setFiles([]);
                            setRemoving(true);
                            setTimeout(() => {
                              setUploading(false);
                              setRemoving(false);
                            }, 1500);
                          }}
                          maxCount={1}
                          accept=".xls, .xlsx, .csv"
                          beforeUpload={() => false}
                          onChange={(e) => uploadChanged(e)}
                          // onRemove={(e) => fileRemoved(e)}
                        >
                          <Button
                            style={{
                              fontFamily: "Poppins",
                              marginLeft: !isEmpty(files) ? "32px" : "",
                            }}
                            icon={<UploadOutlined />}
                          >
                            Browse Your Files
                          </Button>
                        </Upload>
                        <h1
                          className="mt-2 text-center"
                          style={{
                            fontFamily: "Poppins",
                            marginLeft:
                              uploading && !isEmpty(files) ? "42px" : "",
                          }}
                        >
                          {uploading == true && removing === true ? (
                            <p className="flex">
                              <Spin className="mr-1" />
                              Removing.....
                            </p>
                          ) : uploading ? (
                            <p className="flex">
                              <Spin className="mr-1" />
                              Uploading...
                            </p>
                          ) : (
                            ""
                          )}
                        </h1>
                      </div>
                      {/* <div className="input-container">
                        <label for="files" class="btn">
                          <FileOutlined /> Browse Files
                        </label>
                        <input
                          id="files"
                          draggable
                          style={{
                            display: "none",
                          }}
                          type="file"
                        />
                      </div> */}
                    </div>
                  </Col>
                  <Col
                    md={9}
                    className={
                      windowDimensions.height >= 700 &&
                      windowDimensions.height < 830
                        ? "h-[410px]"
                        : windowDimensions.height > 830
                        ? "h-[430px]"
                        : "h-[270px]"
                    }
                  >
                    <Row className="flex flex-col">
                      <Col
                        md={24}
                        className={
                          (windowDimensions.height >= 700 &&
                            windowDimensions.height <= 767) ||
                          (windowDimensions.height > 767 &&
                            windowDimensions.height < 830)
                            ? "border border-1 p-2 ml-5 mb-2 rounded-md h-[330px]"
                            : windowDimensions.height > 830
                            ? "h-[360px] mb-2 border ml-5 border-1 rounded-md"
                            : "h-[210px] mb-2 border ml-5 border-1 rounded-md"
                        }
                      >
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="flex p-2 pl-7 pr-10 justify-between border border-b-1 border-t-0 border-x-0"
                        >
                          <h1>Expected Column</h1>
                          <h1>Required</h1>
                        </div>
                        <div
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className={
                            (windowDimensions.height >= 700 &&
                              windowDimensions.height <= 767) ||
                            (windowDimensions.height > 767 &&
                              windowDimensions.height < 830)
                              ? "border border-1 p-2 rounded-md h-[302px]"
                              : windowDimensions.height > 830
                              ? "border border-1 p-2 rounded-md h-[304px]"
                              : "h-[180px] overflow-y overflow-x-hidden"
                          }
                        >
                          {columns.map((data, index) => {
                            return (
                              <div
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                key={index}
                                className="flex justify-between mb-5 mt-5 pl-7 pr-10"
                              >
                                <h1 className="text-start">{data.title}</h1>

                                <p className="text-start">
                                  <CheckOutlined />
                                </p>
                              </div>
                            );
                          })}
                        </div>
                      </Col>
                      <Col
                        md={24}
                        onClick={() => downloadTemplate()}
                        className="h-[50px] p-2 cursor-pointer border ml-5 border-1 rounded-md"
                      >
                        <h1
                          style={{
                            fontFamily: "Poppins",
                          }}
                          className="text-center"
                        >
                          Download Template
                        </h1>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              {/* <CSVImporter
                  draggable={true}
                  isModal={false}
                  // color="white"
                  slot=""
                  className="Stepper-module_stepper__2HBhf Main-module_wrapper__33d9J Main-module_content__MK50u mt-[-15px]"
                  primaryColor="white"
                  onChange={(data) => console.log(data, "upload")}
                  onComplete={(data) => {
                    console.log(data, "data");
                    setImportedData(data);
                    setImportPreview(true);
                    setTableLoading(true);
                    setTimeout(() => {
                      setTableLoading(false);
                    }, 700);
                    var newFormData = new FormData();
                    var newFile = new File(data.rows, "fileName");
                    newFormData.append(data.rows);
                    console.log(newFormData, "newFormData");
                    var dataFormat = new Blob([data.rows], {
                      type: "text/csv",
                    });
                    var tempLink = document.createElement("a");
                    tempLink.href = window.URL.createObjectURL(dataFormat);
                    // tempLink.setAttribute("download", "filename.csv");
                    // tempLink.click();
                    console.log(tempLink, "tempLink");
                    console.log(newFile, "newFile");
                    console.log(dataFormat, "dataFormat");
                    // toast.success("Customer Imported successfully");
                    // setTimeout(() => {
                    //   history.push("/purchase-invoice");
                    // }, 2000);
                  }}
                  template={{
                    columns: [
                      {
                        name: "S.No",
                        key: "sNo",
                        required: true,
                        //   description: "Vendor Name",
                      },
                      {
                        name: "Vendor Name",
                        key: "vendorName",
                        required: true,
                        //   description: "Vendor Name",
                      },
                      {
                        name: "Purchase Invoice Number",
                        key: "purchaseinvoiceNo",
                        required: true,
                        //   description: "Invoice Number",
                      },
                      {
                        name: "Purchase Invoice Date",
                        key: "purchaseinvoiceDate",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Model Name",
                        key: "modelName",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Grade",
                        key: "grade",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "RAM",
                        key: "ram",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: importMode == "Qty" ? "Qty" : "IMEI No",
                        key: importMode == "Qty" ? "qty" : "imeiNo",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Purchase Price",
                        key: "purchaseprice",
                        required: true,
                        //   description: "Invoice Date",
                      },
                      {
                        name: "Selling Price",
                        key: "sellingPrice",
                        required: true,
                        //   description: "amount",
                      },
                    ],
                  }}
                  skipHeaderRowSelection
                /> */}
            </Col>
            {importPreview == true && current == 1 ? (
              ""
            ) : (
              <Col
                md={24}
                className={
                  windowDimensions.height >= 700 &&
                  windowDimensions.height < 830
                    ? "purchase-invoice-details-footer mt-6"
                    : windowDimensions.height >= 830
                    ? "purchase-invoice-details-footer mt-[100px]"
                    : "purchase-invoice-details-footer"
                }
              >
                <div className="w-[100%]">
                  {/* <div className="pl-[40px] pr-[20px] mt-[-31px] mb-2">
                <h1
                  style={{
                    fontFamily: "Poppins",
                  }}
                  className="flex text-[13px] ml-2 font-medium"
                >
                  Download a{" "}
                  <p className="ml-1 mr-1 text-[#0ba5ec]">template</p> and
                  compare it to your import file to ensure the file perfect
                  for the import
                </h1>
              </div> */}
                  <div className="w-[100%] flex justify-center p-2">
                    <div className="w-[68%] bg-[#f3f3f3] rounded-lg">
                      <div className="flex font-semibold text-[16px] pl-1 pt-1 pr-2 mb-[-11px]">
                        <BulbFilled className="mr-2 text-[#e7e72d]" /> Page Tips
                      </div>
                      <ul
                        style={{
                          listStyleType: "disc",
                          fontFamily: "Poppins",
                          fontSize: "12px",
                        }}
                        className="ml-2 mr-2 pt-3 pb-2 pr-2 pl-4"
                      >
                        <li>
                          {" "}
                          <div className="flex text-[12px] font-medium">
                            Download a{" "}
                            <p
                              className="ml-1 mr-1 text-[#0ba5ec] cursor-pointer"
                              onClick={() => downloadTemplate()}
                            >
                              template
                            </p>{" "}
                            and compare it to your import file to ensure the
                            file perfect for the import
                          </div>
                        </li>
                        <li>Import data with the details of purchase list</li>
                        <li>
                          If you have files in another formats, you can convert
                          it to an accepted file format using any online/offline
                          converter
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
            )}
          </Row>
          {/* )} */}
        </Col>
      </Row>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        style={{
          fontSize: "12px",
        }}
        pauseOnHover
        theme="dark"
      />
    </React.Fragment>
  );
};

CustomerImport.propTypes = {
  location: PropTypes.any,
};

export default CustomerImport;
